import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  foreign_ccy: boolean;
  title: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_internal_settlement: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  relative_txn_date_in_days: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_months: fromDatatype.IntegerDatatypeInterface;
  template_code: fromDatatype.VarcharDatatypeInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_template_hdr_RowClass
  implements bl_fi_generic_doc_template_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  foreign_ccy: boolean;
  title: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  process: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_internal_settlement: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  relative_txn_date_in_days: fromDatatype.IntegerDatatypeInterface;
  relative_txn_date_in_months: fromDatatype.IntegerDatatypeInterface;
  template_code: fromDatatype.VarcharDatatypeInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
}
